module.exports = __webpack_public_path__ + "img/personCertBanner.976c1ed4.png";